export default "__VITE_ASSET__b611043f__"